module.exports = __webpack_public_path__ + "img/Weapon_199.a7551cd2.png";